
import router from "@/router";
import { Actions } from "@/store/enums/StoreEnums";
import { computed, defineComponent, ref } from "vue";
import { useStore } from "vuex";

interface Filter {
  role: string;
  firstName: string;
  lastName: string;
  email: string;
}

export default defineComponent({
  name: "dropdown-users-filter",
  components: {},
  props: {
    tableCallFunction: String,
  },
  setup(props) {
    const store = useStore();
    const tableCallAFunction:string = props.tableCallFunction!;
    const data = ref<Filter>({
      role: "all",
      firstName: "",
      lastName: "",
      email: "",
    });

    const currentUsers = computed(() => {
      return store.getters.currentUsers;
    });

    const resetFilter = () => {
      data.value.role = "all";
      data.value.firstName = "";
      data.value.lastName = "";
      data.value.email = "";
      
      store.dispatch(tableCallAFunction, {
        params: {
          Page: 1,
          RecordsPerPage: 8,
        },
      });
    };

    const applyFilter = () => {
      console.log(currentUsers.value);
      
      store.dispatch(tableCallAFunction, {
        params: {
          Page: 1,
          RecordsPerPage: 8,
          role: data.value.role == "all" ? "" : data.value.role,
          firstname: data.value.firstName,
          lastname: data.value.lastName,
          piEmail: data.value.email,
        },
      });
    };

    return {
      data,
      resetFilter,
      applyFilter,
    };
  },
});
